var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"subheader position-relative"},[_c('h1',{staticClass:"text-center text-white position-relative"},[_vm._v("\n\t\t\t\t"+_vm._s(_vm.$t("not_found.title"))+"\n\t\t\t")])]),_vm._v(" "),_c('div',{staticClass:"bg-vanilla text-brown"},[_c('div',{staticClass:"container p-md-5 py-3"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 text-center"},[_c('h1',[_vm._v(_vm._s(_vm.$t("not_found.text")))])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-89dfe4d4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/404.vue
// module id = 97
// module chunks = 0